import src from "IMAGE";
export default { src, width: 2500, height: 521, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQElEQVR42i3IsQnAIBRF0TdEIBskISgqgoLY2Im6gW7g/r2v+MWBy0XPY5lXFwAfeVIi0o2Z6g6PazIt/WSkrwPuIwYNkrBVjwAAAABJRU5ErkJggg=="};
